var path = '/modules/templates/views/pages/details.tpl.html';
var html = "<h1>{{vm.template.name}}</h1>\n<section>\n    <div class=\"content-box box-template-expanded mt-0\">\n        <al-email-template-editor template-id=\"vm.stateParams.id\"\n                                  on-save=\"vm.handleEditorSave()\"\n                                  on-cancel=\"vm.handleEditorCancel()\"\n                                  cancel-trigger=\"vm.editorCancelTrigger\"></al-email-template-editor>\n    </div>\n</section>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/templates/views/pages/details.tpl.html
// module id = 2158
// module chunks = 1